<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import VipRankRewardsAlternative from "../vip-rank-rewards-alternative.svelte";
import VipSectionTitle from "./vip-section-title.svelte";
</script>

<section class="vip-ranks-benefits">
	<VipSectionTitle title={$t(Verbiage['vip_momentum_ranks_benefits_title'])} />
	<VipRankRewardsAlternative isPadding={false} />
</section>

<style>
	.vip-ranks-benefits {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 1rem
}
</style>
